import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@domain-group/suit-theme'

import { previewOrientation, previewScale } from '@functions/templatePageUtilities'

import styles from './styles.module.scss'

const calculatePreviewStyle = (holderSize, imageSize, imageUrl) => {
  const orientation = previewOrientation(imageSize.height, imageSize.width)
  const scale = previewScale(orientation, holderSize, imageSize.width, imageSize.height)

  const scaledImageSize = {
    width: imageSize.width * scale,
    height: imageSize.height * scale,
  }

  const previewStyle = {
    backgroundImage: imageUrl ? `url(${imageUrl})` : null,
    width: scaledImageSize.width,
    height: scaledImageSize.height,
  }

  return previewStyle
}

const PagePreview = (props) => {
  const {
    holderHeight,
    holderPadding,
    holderWidth,
    imageHeight,
    imageUrl,
    imageWidth,
    style: suppliedStyle,
    children,
  } = props

  const imageSize = {
    width: imageWidth,
    height: imageHeight,
  }

  const holderSize = {
    width: holderWidth,
    height: holderHeight,
    padding: holderPadding,
  }

  const style = calculatePreviewStyle(holderSize, imageSize, imageUrl)

  return (
    <Box as="span" className={styles.preview} display="block" style={{ ...style, ...suppliedStyle }}>
      {children}
    </Box>
  )
}

PagePreview.propTypes = {
  children: PropTypes.node,
  holderHeight: PropTypes.number.isRequired,
  holderPadding: PropTypes.number.isRequired,
  holderWidth: PropTypes.number.isRequired,
  imageHeight: PropTypes.number.isRequired,
  imageUrl: PropTypes.string,
  imageWidth: PropTypes.number.isRequired,
  style: PropTypes.object,
}

export default PagePreview
